import React from 'react';

export default function HeroCarousel() {
  return (
    <section id="hero" className="hero section dark-background">
      <div
        id="hero-carousel"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
        data-bs-interval="5000"
      >
        <div className="carousel-item active">
          <img src="/images/img-bg1.webp" alt="" />
          <div className="carousel-container">
            <h2 className="sitename">
              Welcome to <span className="first-word">Railing&nbsp;</span>
              <span>World</span>
              <br />
            </h2>
            <h4>Aluminium &amp; Stainless steel glass railing system</h4>
            {/* <a href="#featured-services" className="btn-get-started">Get Started</a> */}
          </div>
        </div>
        {/* End Carousel Item */}

        <div className="carousel-item">
        <img src="/images/img-bg2.webp" alt="" />
          <div className="carousel-container">
            <h3>Crafting Excellence in Railing Solutions</h3>
            <p>
                          At Railing World, we specialize in premium aluminum, stainless steel, and glass railings that blend design with durability.
                          Each product reflects our commitment to innovation and aesthetic craftsmanship.
            </p>
            
          </div>
        </div>
        {/* End Carousel Item */}

        <div className="carousel-item">
        <img src="/images/img-bg3.webp" alt="" />
          <div className="carousel-container">
            <h3>Building Strong Bonds Through Quality and Trust</h3>
            <p>
                          Our success is driven by reliable partnerships with architects, engineers, and contractors.
                          We prioritize international standards and lasting relationships with our valued clients.
            </p>
          </div>
        </div>
        {/* End Carousel Item */}

        <a
          className="carousel-control-prev"
          href="#hero-carousel"
          role="button"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon bi bi-chevron-left" aria-hidden="true" />
        </a>

        <a
          className="carousel-control-next"
          href="#hero-carousel"
          role="button"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon bi bi-chevron-right" aria-hidden="true" />
        </a>

        <ol className="carousel-indicators">
          <li data-bs-target="#hero-carousel" data-bs-slide-to="0" className="active" aria-current="true" />
          <li data-bs-target="#hero-carousel" data-bs-slide-to="1" />
          <li data-bs-target="#hero-carousel" data-bs-slide-to="2" />
        </ol>
      </div>
    </section>
  );
}